export const fioLengthValidator = (v, text: string) => {
  if (text.length <= 64) {
    return Promise.resolve();
  }

  return Promise.reject();
};
